import { BlurVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { blur } from '@cloudinary/url-gen/actions/effect'
import { SliderField } from './SliderField'

export const BlurVariant = (props: BlurVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <SliderField
        minValue={1}
        maxValue={2000}
        step={1}
        initialValue={variant.qualifier}
        label="Increase or decrease blur"
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(blur(value))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'blur', qualifier: value })
        }}
      />
    </ImageVariant>
  )
}
